import { useEffect, useState } from 'react';
import { Stack } from '@chakra-ui/react';

import {
  useCreateSignatureDraft,
  useGetSignatureDraft,
  useSignatureDrafts,
} from '~/core/shared/api/signature';
import { useEventHandler } from '~/core/shared/hooks/useEventHandler';
import { Envelope, EnvelopeDraft } from '~/core/shared/types';
import { SmartCommEditor } from './integrations/SmartCommEditor.component';

type EnvelopeDraftEditorProps = {
  envelope: Envelope;
};

export const EnvelopeDraftEditor = ({ envelope }: EnvelopeDraftEditorProps) => {
  const { getSignatureDraft } = useGetSignatureDraft();
  const { createSignatureDraft } = useCreateSignatureDraft();
  const [draft, setDraft] = useState<EnvelopeDraft>();

  const { drafts } = useSignatureDrafts(envelope);

  const selectDraft = useEventHandler(async (id: string) => {
    if (draft && draft.id === id) {
      return;
    }

    const draftData = await getSignatureDraft({ envelope, draftId: id });

    if (draftData) {
      setDraft(draftData);
    }
  });

  const resetDraft = useEventHandler(async () => {
    if (envelope) {
      try {
        const newDraft = await createSignatureDraft(envelope);
        if (newDraft) {
          setDraft(newDraft);
        }
      } catch {
        // error handled in useCreateSignatureDraft
      }
    }
  });

  useEffect(() => {
    if (!drafts) return;

    if (drafts.length > 0 && !draft) {
      selectDraft(drafts[0].id);
    } else if (drafts.length === 0 && !draft) {
      resetDraft();
    }
  }, [drafts]);

  return <Stack>{draft && <SmartCommEditor draftData={draft.data} />}</Stack>;
};
